/**
 * Utility functions to manage the admin splash screen display between sessions
 */

const RECENT_LOGIN_KEY = 'login_time'
const IS_SPLASH_SCREEN_SEEN = 'is_splash_screen_seen'

/**
 * Determines if the admin splash screen should be shown
 * @param isAdmin - Whether the current user has admin privileges
 * @returns boolean - True if the splash should be shown
 */
export const shouldShowAdminSplash = (isAdmin: boolean): boolean => {
    // Non-admin users never see the splash
    return isAdmin && !getSeenSplashScreen()
}

/**
 * Get whether the user has recently logged in
 * @returns boolean
 */
export const getIsRecentlyLoggedIn = (): boolean => {
    const seconds = 120
    const logInTime = localStorage.getItem(RECENT_LOGIN_KEY)
    const currentTime = new Date()

    // if user was recently logged in we show different privacy screen
    return (currentTime.getTime() - new Date(logInTime).getTime()) / 1000 < seconds
}

/**
 * Sets login time
 * @returns void
 */
export const setRecentlyLoggedIn = (): void => localStorage.setItem(RECENT_LOGIN_KEY, new Date().toISOString())

/**
 * Gets the login time
 * @returns string
 */
export const getLogInTime = (): string => localStorage.getItem(RECENT_LOGIN_KEY)

/**
 * Get when the splash screen was last seen
 * @returns string
 */
export const getSeenSplashScreen = (): string => localStorage.getItem(IS_SPLASH_SCREEN_SEEN)

/**
 * Clears the admin splash viewed status (for testing or forcing display)
 * @retuns void
 */
export const resetAdminSplashStatus = (): void => {
    localStorage.removeItem(RECENT_LOGIN_KEY)
    localStorage.removeItem(IS_SPLASH_SCREEN_SEEN)
}

/**
 * Set admin splash screen as shown so we don't constantly show on reloads
 * @returns boolean
 */
export const setAdminSplashSeen = (): void => localStorage.setItem(IS_SPLASH_SCREEN_SEEN, new Date().toISOString())
